/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-11-30 15:25:01
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-06-05 13:56:47
 */
import request from '../../utils/request'
import server from './config'
export default {
    /**
     * 找医生 ，获取医生列表
     */
    getDoctorList:(data,noToast=false)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/doctorRecordStatus/${1}/queryReceiveDoctorList`,
            method: 'post',
            data,
            noToast
        })
    },
    /**
     * 获取医生详情
     */
    getDoctorInfo:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/patient/${1}/getDetailInfo`,
            method: 'post',
            data,
        })
    },
    /**
     * 检测当前医生和患者是否有未结束的咨询
     */
    checkConsulting:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/patient/consult/${1}/checkConsultingReturnList`,
            method: 'post',
            data,
        })
    },
    /**
     * 我的医生列表
     */
    patientMemberDoctorList:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/patient/${1}/patientMemberDoctorList`,
            method: 'post',
            data,
        })
    },
    /**
     * 医生注册验证码
     */
    doctorRegCode:(data)=>{
        return request({
            url:`${server.MS_PROJECT_CONSUMMER}/login/${1}/login/sendDoctorRegistrationSmsCode`,
            method: 'post',
            data,
        })
    },
    /**
     * 医生注册
     */
    doctorReg:(data)=>{
        return request({
            url:`${server.MS_PROJECT_CONSUMMER}/login/1/login/userDoctorRegistration`,
            method: 'post',
            data,
        })
    },

    /**
     * 绑定代表
     */
    userDoctorUpdate:(data)=>{
        return request({
            url:`${server.MS_PROJECT_CONSUMMER}/login/1/login/userDoctorUpdate`,
            method: 'post',
            data,
        })
    },
    /**
     * 代表详情
     */
    queryUserInfoById(data){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/user/1/queryUserInfoById`,
            method: 'post',
            data
        })
    },
    /**
     * 医生注册
     */
    patientBlackCheck:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/patient/${1}/patientBlackCheck `,
            method: 'post',
            data,
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/modules/doctor.js